import { Box, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import SummaryAsProductNo from './summary/SummaryAsProductNo'
import useMediaQuery from '@mui/material/useMediaQuery'
import SummaryAsWorker from './summary/SummaryAsWorker'
import TableMain from './table/TableMain'
import { useRecoilValue } from 'recoil'
import { diaryListState } from '../../../states/diaryListState'
import {
  gatherDairyListAsWorkerAndProductNoAndSiteName,
  gatherDairyListAsProductNoAndSiteName,
} from '../../../utils/functions/summary'
import { summaryByProductNo, summaryByWorker } from '../../../types/dirary'
import { calendarListState } from '../../../states/calendarListState'
import { processListState } from '../../../states/processListState'
import { zoomState } from '../../../states/zoomState'
const DisplayArea = () => {
  const diaryList = useRecoilValue(diaryListState)
  const calendar = useRecoilValue(calendarListState)
  const processList = useRecoilValue(processListState)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))
  const isIphone = useMediaQuery(theme.breakpoints.down('sm'))
  const [summaryAsWorker, setSummaryAsWorker] = useState<summaryByWorker[]>([])
  const [summaryAsProductNo, setSummaryAsProductNo] = useState<
    summaryByProductNo[]
  >([])
  useEffect(() => {
    const resultAsWorker =
      gatherDairyListAsWorkerAndProductNoAndSiteName(diaryList)
    setSummaryAsWorker(resultAsWorker)
    const resultAsProductNo =
      gatherDairyListAsProductNoAndSiteName(resultAsWorker)
    setSummaryAsProductNo(resultAsProductNo)
  }, [diaryList])

  const zoomLevel = useRecoilValue(zoomState)
  const zoom = parseFloat(zoomLevel) || 1
  return (
    <Box
      sx={{
        display: 'flex',
        paddingTop: '10px',
        gap: '10px',
        flexDirection: 'column',
        overflowY: 'auto',
        maxHeight: `${
          isIphone
            ? `calc((100vh - 160px * ${zoom}) / ${zoom})`
            : isMobile
            ? `calc((100vh - 170px * ${zoom}) / ${zoom})`
            : `calc((100vh - 140px * ${zoom} ) / ${zoom})`
        }`,
      }}
    >
      {summaryAsProductNo.map((productSummary, productIndex) => (
        <SummaryAsProductNo
          key={`${productSummary.productNo}-${productSummary.productBno}-${productSummary.constructionId}-${productSummary.factoryId}`}
          summary={productSummary}
          processList={processList}
        >
          {summaryAsWorker
            .filter(
              (workerSummary) =>
                workerSummary.constructionId ===
                  productSummary.constructionId &&
                workerSummary.productNo === productSummary.productNo &&
                workerSummary.productBno === productSummary.productBno &&
                // workerSummary.siteName === productSummary.siteName &&
                workerSummary.factoryId === productSummary.factoryId
            )
            .map((workerSummary, workerIndex) => (
              <SummaryAsWorker
                key={`${workerSummary.workerId}-${workerSummary.productNo}-${workerSummary.productBno}-${workerSummary.constructionId}-${workerSummary.factoryId}`}
                summary={workerSummary}
              >
                <TableMain
                  key={`${workerSummary.workerId}-${workerSummary.productNo}-${workerSummary.productBno}-${workerSummary.constructionId}-${workerSummary.factoryId}`}
                  calendar={calendar}
                  processList={processList}
                  diaryList={diaryList}
                  summaryByWorker={workerSummary}
                  summaryByProductNo={productSummary}
                />
              </SummaryAsWorker>
            ))}
        </SummaryAsProductNo>
      ))}
    </Box>
  )
}

export default DisplayArea
